export class Projet {
    idprojet: number;
    libelleprojet: string;
    idtypeprojet: number;
    datedebut: string;
    datefin: string;
    datefineffective: string;
    description: string;
    codeprojet: string;
    etat: number;
    idcreateur: number;
    societe: number;
    statut: number;
    date_creation: string;
    poles: Array<number>;
    directions: Array<number>;
    porteurs: Array<number>;
}



// WEBPACK FOOTER //
// /Users/numherit/PhpstormProjects/TEMPLATES/sunuprojet/src/app/models/projet.ts